export function saveFields(
  storageKey: string | undefined,
  fields: string[],
): void {
  if (!storageKey || typeof window === 'undefined') return
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(fields))
  } catch (e) {
    console.warn('[fieldStorage] localStorage への保存に失敗しました', e)
  }
}

// 「一度でも選択肢に出たカラム」の記録先。
// 保存済みの選択リストだけでは、後から追加したカラムが
// 既存ユーザーの画面に永久に出ないため別途記録している。
const knownStorageKey = (storageKey: string): string => `${storageKey}_known`

// 既知カラムの記録を導入する前に追加したカラム。
// 記録が無い初回は、ユーザーが外したカラムと新しいカラムの区別がつかないため、
// 基本はすべて既知とみなし(外したカラムを復活させない)、ここに挙げたカラムだけを新しいカラムとして扱う。
const FIELDS_ADDED_BEFORE_KNOWN_TRACKING = [
  'campaign_referral_count',
  'campaign_purchase_count',
  'campaign_point',
]

function loadKnownFields(storageKey: string): string[] | null {
  try {
    const raw = window.localStorage.getItem(knownStorageKey(storageKey))
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter((f): f is string => typeof f === 'string') : null
  } catch (e) {
    console.warn('[fieldStorage] 既知カラムの読み込みに失敗しました', e)
    return null
  }
}

function saveKnownFields(storageKey: string, fields: string[]): void {
  try {
    window.localStorage.setItem(knownStorageKey(storageKey), JSON.stringify(fields))
  } catch (e) {
    console.warn('[fieldStorage] 既知カラムの保存に失敗しました', e)
  }
}

export function loadFields(
  storageKey: string | undefined,
  allFields: string[],
): string[] {
  if (!storageKey || typeof window === 'undefined') return allFields
  try {
    const raw = window.localStorage.getItem(storageKey)
    if (!raw) return allFields
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return allFields
    const fieldSet = new Set(allFields)
    const filtered = parsed.filter(
      (f): f is string => typeof f === 'string' && fieldSet.has(f),
    )
    if (filtered.length === 0 && parsed.length > 0) return allFields

    // 初めて現れたカラムは選択状態にして表示する。
    const known =
      loadKnownFields(storageKey) ??
      allFields.filter(f => !FIELDS_ADDED_BEFORE_KNOWN_TRACKING.includes(f))
    const newFields = allFields.filter(f => !known.includes(f))
    if (allFields.length > 0) {
      saveKnownFields(storageKey, Array.from(new Set([...known, ...allFields])))
    }
    if (newFields.length === 0) return filtered

    // 選択状態も保存する。既知の記録だけ更新すると、次の読み込みで
    // 「既知かつ未選択」となり、新しいカラムが1回表示されただけで消えてしまうため。
    const selected = [...filtered, ...newFields]
    saveFields(storageKey, selected)
    return selected
  } catch (e) {
    console.warn('[fieldStorage] localStorage からの読み込みに失敗しました', e)
    return allFields
  }
}
